<template>
  <div class="trim checkbox-label-equipment d-flex align-items-center w-100">
    <div class="input-group">
      <div
        class="checkbox-label-equipment equipment-checkbox mr-auto custom-checkbox custom-checkbox--primary"
      >
        <input
          :id="`trim-equipment-${_uid}`"
          type="checkbox"
          class="input-checkbox mr-2"
          :checked="value.isSelected"
          :disabled="value.isDisabled"
          @change="toggleSelection(value)"
        />
        <label :for="`trim-equipment-${_uid}`">{{ value.name }}</label>
      </div>
    </div>
    <Popper
      v-if="!isDisabled"
      :content="switchToImportantTooltipMessage"
      hover
      placement="left"
      offset-distance="42"
      arrow
      class="custom-control custom-switch popper--secondary"
    >
      <input
        :id="_uid"
        :checked="value.isImportant"
        type="checkbox"
        class="custom-control-input"
        @change="toggleImportantFlag(value, $event)"
      />
      <label class="custom-control-label" :for="_uid"></label>
    </Popper>
    <Popper
      v-else
      :content="switchToImportantTooltipMessage"
      hover
      placement="left"
      offset-distance="42"
      arrow
      class="custom-control custom-switch popper--secondary custom-switch--disabled"
    >
      <input
        :id="_uid"
        disabled
        :checked="value.isImportant"
        type="checkbox"
        class="custom-control-input"
      />
      <label class="custom-control-label" :for="_uid"></label>
    </Popper>
  </div>
</template>

<script>
import EquipmentSelector from '@components/equipment/EquipmentSelector.vue'
import EquipmentImportantSwitch from '@components/equipment/EquipmentImportantSwitch.vue'
import { useId } from 'vue'
import { wTrans } from 'laravel-vue-i18n'
export default {
  name: 'TrimEquipmentItem',
  components: { EquipmentSelector, EquipmentImportantSwitch },
  props: {
    group: {
      type: String,
      default: ''
    },
    value: {
      type: Object,
      default() {
        return {
          isSelected: false,
          isDisabled: false
        }
      }
    }
  },
  computed: {
    _uid() {
      return useId()
    },
    maxLimit() {
      return this.$store.getters['trimEquipment/maxLimit']
    },
    selectedImportantCount() {
      return this.$store.getters['trimEquipment/selectedImportantCount']
    },
    hasReachedImportantLimit() {
      return this.selectedImportantCount >= this.maxLimit
    },
    switchToImportantTooltipMessage() {
      if (!this.isImportant && this.hasReachedImportantLimit) {
        return (
          wTrans('components/equipments.tooltips.important.switchDisabledMaxLimit', {
            count: this.selectedImportantCount
          })?.value ?? ''
        )
      }

      if (this.isImportant) {
        return this.$t('components/equipments.tooltips.important.switchDisabled')
      }

      return this.$t('components/equipments.tooltips.important.switch')
    },
    isSelected() {
      return this.value.isSelected
    },
    isImportant() {
      return this.value.isImportant
    },
    isSelectedButNotImportant() {
      return this.isSelected && !this.isImportant
    },
    isDisabled() {
      return !this.isSelected || (this.isSelectedButNotImportant && this.hasReachedImportantLimit)
    }
  },
  methods: {
    toggleSelection(equipment) {
      let updatedEquipment = Object.assign(equipment, {
        isSelected: !equipment.isSelected,
        isImportant: false
      })
      this.updateEquipment(updatedEquipment)
    },
    toggleImportantFlag(equipment, event) {
      let updatedEquipment = Object.assign(equipment, {
        isImportant: !equipment.isImportant
      })
      this.updateEquipment(updatedEquipment)
    },
    updateEquipment(equipment) {
      this.$store.dispatch('trimEquipment/update', {
        group: this.group,
        equipment: equipment
      })
    }
  }
}
</script>
